import { FC, ReactNode } from 'react';
import { FormControlLabel, FormControl, FormLabel, RadioGroup, Radio } from '@mui/material';
import { FieldProps, useField } from 'formik';

type Option = {
  label: string;
  value: string;
};

type RadioFieldProps = FieldProps & {
  label: ReactNode;
  submitOnChange?: boolean;
  options: Option[];
  defaultValue: string;
  row?: boolean;
  className?: string;
};

export const RadioField: FC<RadioFieldProps> = ({
  field,
  label,
  form,
  submitOnChange = true,
  defaultValue,
  options,
  row,
  className
}) => {
  const [, , helpers] = useField(field.name);

  return (
    <FormControl size="small" className={className}>
      <FormLabel>{label}</FormLabel>

      <RadioGroup
        {...field}
        defaultValue={defaultValue}
        row={row}
        onChange={(event) => {
          helpers.setValue(event.target.value);

          if (submitOnChange) {
            form.submitForm();
          }
        }}
      >
        {options.map(({ value, label }) => (
          <FormControlLabel value={value} control={<Radio size="small" />} label={label} key={value} />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
